// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"33":"dbf06a53","61":"b2bdda3b","209":"cfb95753","866":"d20571d7"}[chunkId] + ".chunk.css";
};